import { Button, Box } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../shared/state/root-reducer';
import { useMemo } from 'react';
import { ChannelCode } from '../state/payment-context-slice';

export const PaymentHubButton = () => {
  const location = useLocation();
  const selectedEncounter = useSelector((state: RootState) => state.patientContext?.selectedEncounter);
  const selectedPatient = useSelector((state: RootState) => state.patientContext?.selectedPatient);
  const roleType = useSelector((state: RootState) => state.userContext?.userProfile?.userRole?.roleType) as 'I' | 'E' | undefined;

  // Determine channel code based on current route and user role
  const channelCode = useMemo((): ChannelCode => {
    const path = location.pathname;
    
    // Estimates, VOB, and Patients: internal users get FMS, external users get CRM
    if (path.includes('/estimates') || path.includes('/estimate') || path.includes('/vob') || path.includes('/patients')) {
      return roleType === 'E' ? 'crm' : 'fms';
    }
    
    // Specialist: default to FMS
    if (path.includes('/specialist')) {
      return 'fms';
    }
    
    // Default to FMS
    return 'fms';
  }, [location.pathname, roleType]);

  const to = useMemo(() => {
    let basePath = '/hub';
    
    if (selectedEncounter?.patientId && selectedEncounter?.patientEncounterId) {
      basePath = `/hub/patient/${selectedEncounter.patientId}/ioc/${selectedEncounter.patientEncounterId}`;
    } else if (selectedPatient?.patientId) {
      basePath = `/hub/patient/${selectedPatient.patientId}`;
    } else {
      const match = location.pathname.match(/^\/specialist\/dashboard\/(\d+)(?:\/|$)/);
      if (match) {
        basePath = `/hub/patient/${match[1]}`;
      }
    }
    
    return `${basePath}?ch=${channelCode}`;
  }, [location.pathname, selectedEncounter?.patientId, selectedEncounter?.patientEncounterId, selectedPatient?.patientId, channelCode]);

  return (
    <Box sx={{
      position: 'absolute',
      right: '2rem',
      top: 0,
      bottom: 5,
      display: 'flex',
      alignItems: 'center',
      zIndex: 2,
      '@media (min-width: 960px)': { right: '7rem' }
    }}>
      <Button
        component={Link}
        to={to}
        variant="contained"
        test-id="payment-hub-button"
        sx={{
          backgroundColor: '#297ec1',
          color: 'white',
          fontSize: '1.6rem',
          fontWeight: 600,
          textTransform: 'none',
          fontFamily: 'Inter, "Helvetica Neue", sans-serif',
          '&:hover': {
            backgroundColor: '#1f5f9a',
          },
        }}
      >
        Payment Hub
      </Button>
    </Box>
  );
};
